// extracted by mini-css-extract-plugin
export var inner = "index-module--inner--eqhmD";
export var logo = "index-module--logo--845IG";
export var lookDetail = "index-module--lookDetail--eYkug";
export var p1 = "index-module--p1--Se1MJ";
export var technicalAdvantages = "index-module--technicalAdvantages--plbJq";
export var technicalAdvantagesList = "index-module--technicalAdvantagesList--eFBPV";